module.exports = "pegasus/assets/themelp1/charity/109.png";